import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../supabase_client';

const SupabaseUserContext = createContext(null);

export const SupabaseUserProvider = ({ children }) => {
  const [supabaseUser, setSupabaseUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setSupabaseUser(user);
    };
    fetchUser();
    const { data: listener } = supabase.auth.onAuthStateChange(() => {
      fetchUser();
    });
    return () => {
      listener?.subscription?.unsubscribe();
    };
  }, []);

  return (
    <SupabaseUserContext.Provider value={supabaseUser}>
      {children}
    </SupabaseUserContext.Provider>
  );
};

export const useSupabaseUser = () => useContext(SupabaseUserContext); 